// @flow
/* eslint-disable no-shadow */
import React from 'react';
import Toggle from 'react-toggled';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ListItem from '@material-ui/core/ListItem';
import capitalize from 'lodash/capitalize';
import { withTranslation } from 'react-i18next';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import CachedOutlinedIcon from '@material-ui/icons/CachedOutlined';
import CloudOutlinedIcon from '@material-ui/icons/CloudOutlined';
import Divider from '@material-ui/core/Divider';
import { backends, updateBackend, updateBackendAva } from '../../utils/http';
import { styles, EmptyIcon } from '../../modules/scribe/SidebarHelpers';
import { clearScribeConversationState, reconnectToWebSocket, toggleSideBar } from '../../actions';

function index({
  backends: backendsAva,
  classes,
  currentPlatform,
  displayable,
  t,
  toggleSideBar,
  reconnectToWebSocket,
  sidebarOpen,
}: {
  backends: Object,
  classes: Object,
  clearScribeConversationState: Function,
  currentPlatform: string,
  displayable: Object,
  reconnectToWebSocket: Function,
  toggleSideBar: Function,
  t: Object,
  sidebarOpen: boolean,
}) {
  const handleReconnectToWebSocket = () => {
    reconnectToWebSocket();
    toggleSideBar();
  };

  const getBackendBadgeColor = (color, backendId) => {
    if (color) {
      return `#${color}`;
    }

    switch (backendId) {
      case 'playground':
      case 'stage':
        return 'steelblue';
      case 'production':
      case 'prod':
        return 'seagreen';
      default:
        return 'saddlebrown';
    }
  };

  const onChangeToggleState = (serverListOpen: boolean) => {
    if (sidebarOpen !== serverListOpen) {
      toggleSideBar();
    }
  };

  if (!displayable.dev) {
    return null;
  }

  return (
    <>
      <Divider />
      <Toggle onToggle={(on, object) => onChangeToggleState(on)}>
        {({ on, getTogglerProps }) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <ListItem button {...getTogglerProps()}>
              <ListItemIcon>
                <CloudOutlinedIcon />
              </ListItemIcon>
              {sidebarOpen && (
                <ListItemText classes={{ root: classes.listItemText }} primary={t('sidebar.serverSettings')} />
              )}
              <ListItemIcon classes={{ root: classes.expandIcon }}>
                {on ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
              </ListItemIcon>
            </ListItem>
            <Collapse in={on}>
              <List>
                {currentPlatform === 'web' &&
                  Object.keys(backendsAva).map(backendId => {
                    const backendColor = getBackendBadgeColor(backendsAva[backendId].color, backendId);
                    return (
                      <ListItem
                        key={backendId}
                        button
                        style={{
                          display:
                            localStorage.getItem('avaBackendUrl') === backendsAva[backendId].url ? 'none' : undefined,
                        }}
                      >
                        <EmptyIcon />
                        <ListItemText
                          classes={{ root: classes.listItemText }}
                          onClick={() => updateBackendAva(backendId, backendsAva)}
                          primary={backendsAva[backendId].name ? backendsAva[backendId].name : capitalize(backendId)}
                          style={{
                            backgroundColor: backendColor,
                            color: 'white',
                            fontSize: 14,
                          }}
                        />
                      </ListItem>
                    );
                  })}
                {currentPlatform === 'web' &&
                  displayable.dev && [
                    <ListItem key="reconnect" onClick={() => handleReconnectToWebSocket()} role="button" button>
                      <ListItemIcon>
                        <CachedOutlinedIcon />
                      </ListItemIcon>
                      <ListItemText
                        classes={{ root: classes.listItemText }}
                        primary={t('sidebar.reconnectToBackend')}
                      />
                    </ListItem>,
                  ]}
              </List>
            </Collapse>
          </div>
        )}
      </Toggle>
    </>
  );
}

const mapStateToProps = ({ scribeSession: { backends, currentPlatform, displayable, sidebar } }) => ({
  backends,
  currentPlatform,
  displayable,
  sidebarOpen: sidebar,
});

export default connect(mapStateToProps, {
  clearScribeConversationState,
  reconnectToWebSocket,
  toggleSideBar,
})(withTranslation()(withStyles(styles, { withTheme: true })(withRouter(index))));
